import { Modal } from "flowbite-react";
import { useEffect, useState } from "react";
import { PaymentInfo } from "../../../../../../../types/payment.type";
import { useToastContext } from "../../../../../../../common/components/ui/toast/toast.context";
import FormEditPayments from "../form/FormEditPayments";
import Loading from "../../../../../../../common/components/ui/loading/Loading";
import FromInstallmentsPayments from "../form/FormInstallmentsPayments";
import { getPaymentsById, updatedPayment } from "../../../../../../../common/services/payments.api";
import { getRenterById } from "../../../../../../../common/services/renters.api";
import { IRenter } from "../../../../../../../types/renter.type";

type Props = {
  payments: PaymentInfo[];
  billingId: { _id: string } | null;
  onClose: () => void;
  data: PaymentInfo;
  renterId: string;
  renterName: string;
  action: string;
}
export default function ModalEditPayments(props: Props) {
  const handleCloseModal = () => { props.onClose(); };
  const [billingId, setBillingId] = useState<string | null>(null);
  const [billingData, setBillingData] = useState<PaymentInfo | undefined>(undefined);
  const { notifySuccess, notifyError } = useToastContext();
  const [dataBilling, setDataBilling] = useState<PaymentInfo | undefined>(undefined);
  const [renterData, setRenterData] = useState<IRenter | null>(null)
  const paymentStatus = props.data.status;
  const description = props.data.description

  useEffect(() => {
    if (props.billingId && props.billingId._id !== billingId) {
      setBillingId(props.billingId._id);
    } else if (!props.billingId) { setBillingId(null); }
  }, [props.billingId, billingId]);

  useEffect(() => {
    async function loadBillingData(billingId: string) {
      if (!billingId) return;

      const { data, ok } = await getPaymentsById(billingId);

      if (ok) {
        if (!/DO PLANO SV/i.test(description) && paymentStatus === 'OVERDUE' && data) {
          setBillingData(data as unknown as PaymentInfo);
        }
        setDataBilling(data as unknown as PaymentInfo);
      }
    }
    if (billingId) loadBillingData(billingId);
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [billingId]);

  useEffect(() => {
    async function loadRenterData(renterId: string) {
      if (!renterId) return;

      const { data, ok } = await getRenterById(renterId)

      if (ok) {
        setRenterData(data as IRenter)
      }
    }

    setRenterData(null)

    if (props.renterId) loadRenterData(props.renterId)

  }, [props.renterId])

  async function updatePayment(paymentData: Partial<PaymentInfo>) {
    try {

      const response = await updatedPayment(billingId as string, paymentData);
      const { ok, data, errors } = response;

      if (ok && data) {

        notifySuccess('Fatura atualizada com sucesso!');
      }

      if (!ok) {
        notifyError(response.message as string);
      }
      return { ok, data: data as PaymentInfo, errors: errors as [{ message: string, path: string[] }] }

    } catch (error) {
      notifyError('Erro ao atualizar pagamento!');
      return {
        ok: false,
        data: paymentData,
        errors: [{ message: 'Erro ao atualizar pagamento!', path: [] }]
      }
    }
  }

  return (
    <Modal
      size={'5xl'}
      className='relative dark:text-black'
      show={true}
      onClose={() => handleCloseModal()}
    >
      <Modal.Header>
        <div className="flex items-center justify-start gap-3">
          <span className='text-black'>
            {props.action === "editBilling" ? `Editando Fatura - Cliente: ${props.renterName} ` : `Editando Parcela - Cliente: ${props.renterName}`}
            {/* {`Editando Fatura`} */}
          </span>
        </div>
      </Modal.Header>
      <Modal.Body>
        {dataBilling ? (
          props.action === "editBilling" ? (
            <FormEditPayments
              onSave={(data) => (data)}
              onSubmit={updatePayment}
              data={dataBilling}
              renterId={props.renterId}
              paymentOverdue={billingData}
            />
          ) : (
            <FromInstallmentsPayments
              paymentOverdue={billingData}
              payments={props.payments}
              data={dataBilling}
              renterId={props.renterId}
              renter={renterData!}
            />
          )
        ) : (
          <Loading />
        )}
      </Modal.Body>
    </Modal>
  )
}